<template lang="pug">
  transition(name='modal')
    div(class="c-modal", @click.self="$emit('hide')")
      div(class="c-modal__content u-px4 u-pb4 u-center", :style="{width: width}", style='overflow:visible', :class='modalClass')
        img(class='c-modal__confirm' src='/images/error.png')
        h3(class='u-color-dark u-fz-h1 u-center u-mt2 u-mb3 u-fw-s-bold') ¡UPS!
        p(class='u-fz-h4 u-py2') Al parecer hubo un problema&nbsp;
          br
          | Por favor vuelva a intentarlo.

        button(class='c-btn--error u-9/12@tablet u-12/12' @click="$emit('hide')") Aceptar
</template>

<script>
  export default {
    props: {
      width: {
        type: String,
        default: '360px'
      },
      modalClass: String
    },

    mounted () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/ModalError.vue